import {Service} from "@/apiServices/Service";

export class AwsService extends Service {
    constructor() {
        super("aws/");
    }

    obtenerTokenAcceso() {
        return this.http.get(this.getUrl(['credenciales']))
            .then((response) => this.onData(response))
            .catch(this.onError)
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerTokenAccesoPti() {
        return this.http.get(this.getUrl(['credenciales','pti']))
            .then((response) => this.onData(response))
            .catch(this.onError)
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerTokenAccesoGenerico(){
        return this.http.get(this.getUrl(['credenciales','genericas']))
            .then((response) => this.onData(response))
            .catch(this.onError)
            .finally(() => {
                this.onFinaly();
            })
    }
}